"use strict";
// Reusable Stevie Images for tiles
Object.defineProperty(exports, "__esModule", { value: true });
exports.spritesBattlescapeFloor = void 0;
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var minigolfLayers_sidecar_1 = require("../scene/minigolfLayers-sidecar");
exports.spritesBattlescapeFloor = imageRecycler_sidecar_1.imageRecycler.create('minigolf-battlescape-floor', function () { return minigolfLayers_sidecar_1.minigolfLayers.getLayers().board; });
